import { FC, useMemo } from 'react';
import { Box, Image, VStack } from '@chakra-ui/react';

import { InvoiceStatus } from '__generated__/GQL';
import easyImg from 'assets/brand/easy@2x.png';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

import { EmailReminder } from './components/EmailReminder';
import { PaymentMethods } from './components/PaymentMethods';
import locales from './locales';
import { SidebarProps } from './types';

const STATUSES_ALLOWED_FOR_REMINDERS: ReadonlyArray<string> = [
  InvoiceStatus.Sent,
  InvoiceStatus.Overdue,
  InvoiceStatus.Pending,
];

export const Sidebar: FC<SidebarProps> = ({ client, invoice }) => {
  const canSendReminder = useMemo(
    () => STATUSES_ALLOWED_FOR_REMINDERS.includes(invoice.status),
    [invoice.status],
  );

  return (
    <Box padding="space-24">
      <Image
        alt=""
        boxSize="90px"
        marginBottom="space-24"
        role="presentation"
        src={easyImg}
      />

      <Heading marginBottom="space-16">{locales.title}</Heading>
      <Text marginBottom="space-24">{locales.description}</Text>

      <VStack spacing="space-16">
        <PaymentMethods invoiceData={invoice} />

        {canSendReminder ? (
          <EmailReminder client={client} invoice={invoice} />
        ) : null}
      </VStack>
    </Box>
  );
};
